import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { editUsuario, fetchUsuarios } from '../../actions/usuariosActions';
import { clearLogisticaForSeller, fetchSeller, resetSellers, updateListSellers } from '../../actions/sellersActions';
import { editando, setObject } from '../../actions/generalActios';
//import { fetchTiposPublicacion } from '../../actions/publicacionesActions';
import { fetchTiposPublicacionAdmById } from '../../actions/tiposPublicacionActions';
import {
    putSeller,
    deleteSellerApi,
    postTiposPublicacionAsociarSeller,
    updateCdnSellerApi,
    postCrearCdnSellerApi,
    postCargarDatosBancariosApi,
    postCargarDatosBancariosManualApi
} from '../../api/axios';
import DatosContactos from './DatosContactos';
import DatosBasicos from './DatosBasicos';
import Publicacion from './Publicacion';
import Contraseña from './Contraseña';
import Moderador from './Moderador';
import MailUsuario from './MailUsuario';
import Liquidacion from './Liquidacion';
import Tab from '../General/Tab';
import ModalItem from '../General/Modal';
import GoBackArrow from '../General/GoBackArrow';
import MiniSpinner from '../General/MiniSpinner';
import BigSpinner from '../General/BigSpinner';
import LogisticaPropia from "./LogisticaPropia";
import { isEmail } from '../../utilities/formatString';
import { toast } from 'react-toastify';
import BannerTienda from './BannerTienda';
import DatosBancarios from './DatosBancarios';
import { formatFile } from '../../utilities/formatFile';
import { withNavigation } from '../General/withNavigation';
import Zipnova from './Zipnova';
import { resolveTipoPublicacionId } from '../../helper/tipoPublicacionHelper';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';

// Wrapper para usar hooks en class component
function SellerEditWrapper(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    return <SellerEdit {...props} navigate={navigate} id={id} location={location} />;
}

class SellerEdit extends React.Component {
    constructor(props) {
        super(props);
        const { isCategory, isAdminMod, isSellerAdmin } = this.props.userType;
        this.isSeller = !isCategory && !isAdminMod && !isSellerAdmin;

        this.state = {
            activeTab: this.props.location.state ?? 0,
            tabs: [
                { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos /> },
                { name: "Datos de contactos", icon: "ti-home", content: <DatosContactos /> },
                { name: "Publicación ", icon: "mdi mdi-tag", content: <Publicacion history={this.props.history} /> },
                {
                    name: "Moderador", icon: "ti-home",
                    content: <Moderador
                        tipoUsuario={this.props.tipoUsuario}
                        changeTab={this.onChangeActiveTab}
                        navigate={this.props.navigate}
                        location={this.props.location} />

                },
                { name: "Administrar Cuenta", icon: "mdi mdi-email-outline", content: <MailUsuario /> },
                { name: "Liquidacion", icon: "mdi mdi-google-analytics", content: <Liquidacion tipoUsuario={this.props.tipoUsuario} /> },
                ...(isCategory || isAdminMod) ? [
                    { name: "Banner Tienda", icon: "ti-home", content: <BannerTienda tipoUsuario={this.props.tipoUsuario} /> }
                ] : [],
                { name: "Datos Bancarios", icon: "mdi mdi-tag", content: <DatosBancarios tipoUsuario={this.props.tipoUsuario} onSendPdf={this.handlePdfFromBankData} idSeller={parseInt(this.props.id)} onChangeBankData={this.handleBankDataChange} /> },
                ...(isSellerAdmin) ? [
                    {
                        name: "ZIP Nova",
                        icon: "ti-home",
                        content: <Zipnova
                                    tipoUsuario={this.props.tipoUsuario}
                                    idSeller={parseInt(this.props.id)}
                                    id={this.props.userId}
                                 />
                    }
                ] : [],
            ],
            showSpinner: false,
            originalCdns: [],
            archivoPdf: "",
            hasPdf: false,
            logisticaPropiaEscalas: [],
            datosBancariosForm: null,
            hasCbuManual: false,
        };
    }

    componentDidMount() {
        if (this.props.location.pathname !== `/Sellers/Editar/Select/${this.props.id}`) {
            this.props.setObject({});
        }

        this.props.editUsuario({});
        this.props.editando(true);
        this.props.fetchSeller(this.props.id);

        this.props.fetchUsuarios({ idSeller: parseInt(this.props.id) });
        //this.props.fetchTiposPublicacion(parseInt(this.props.id));

        if (this.props.location.pathname !== `/Sellers/Editar/Select/${this.props.id}`) {
            this.props.fetchTiposPublicacionAdmById({ idSeller: parseInt(this.props.id) });
        }


        if (this.isSeller) {
            let tabsSeller = [
                { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos estado={this.props.seller.estado} /> },
                { name: "Datos de contactos", icon: "ti-home", content: <DatosContactos /> },
                { name: "Publicación", icon: "ti-home", content: <Publicacion history={this.props.history} /> },
                { name: "Administrar Cuenta", icon: "mdi mdi-email-outline", content: <MailUsuario /> },
                { name: "Datos Bancarios", icon: "mdi mdi-tag", content: <DatosBancarios tipoUsuario={this.props.tipoUsuario} onSendPdf={this.handlePdfFromBankData} idSeller={parseInt(this.props.id)} onChangeBankData={this.handleBankDataChange} /> },
            ]

            this.setState({ tabs: tabsSeller });
        }
    }

    componentDidUpdate(prevProps) {
        // Si cambia el id del seller, limpiar el objeto general para evitar valores viejos
        if (this.props.id !== prevProps.id) {
            this.props.setObject({});
            this.setState({ promesaEntregaTemp: this.props.seller?.promesaEntrega ?? '' });
        }

        if (this.props.seller?.promesaEntrega !== prevProps.seller?.promesaEntrega) {
            this.setState({ promesaEntregaTemp: this.props.seller?.promesaEntrega ?? '' });
        }

        if (this.props.seller !== prevProps.seller) {
            const { cdn, envioPropio } = this.props.seller;

            if (envioPropio === true) {
                const isSeller = this.props.userType.isSellerAdmin || this.props.userType.isSeller;
                const tabLogisticaPropia = {
                    name: "Logística Propia",
                    icon: "ti-home",
                    content: (
                        <LogisticaPropia
                            idSeller={this.props.id}
                            userType={this.props.userType}
                            readOnly={!isSeller} // Solo los sellers pueden editar
                            zonas={this.state.logisticaPropiaZonas}
                            onChangeZonas={this.handleChangeZonas}
                            logisticaPropia={this.props.seller.logisticaPropia}
                        />
                    )
                };
                const tabExists = this.state.tabs.some(tab => tab.name === "Logística Propia");
                if (!tabExists) {
                    this.setState(prev => ({ tabs: [...prev.tabs, tabLogisticaPropia] }));
                }
            }

            if (this.state.originalCdns.length === 0 && Array.isArray(cdn)) {
                this.setState({
                    originalCdns: JSON.parse(JSON.stringify(cdn))
                });
            }
        }
    }

    onChangeActiveTab = (index) => { this.setState({ activeTab: index }) };

    onSubmit = async (event) => {
        event.preventDefault();

        const { usuarioError, usuario, seller } = this.props;
        const { isCategory, isAdminMod } = this.props.userType;
        const isAdminModOrIsCategory = isAdminMod || isCategory;

        if (isAdminModOrIsCategory) {
            try {
                if (this.hayCambiosEnCDNs()) {
                    await this.actualizarCDNSeller(seller.codigo);
                }
                this.updateSeller(); // solo si no hay error arriba
            } catch (err) {
                // se frena todo si falla
                console.error("Fallo en actualizarCDNSeller", err);
                return;
            }
        } else {
            //if (usuarioError && JSON.stringify(usuario) !== "{}") {
            if (JSON.stringify(usuario) !== "{}") {
                setTimeout(() => {
                    if (!usuario.error) {
                        this.props.editUsuario({});
                        this.submitFromSeller();
                    }
                }, 500);
            } else {
                if (JSON.stringify(usuario) !== "{}") {
                    toast.error("Las contraseñas no coinciden");
                }
                if (!usuarioError) {
                    this.submitFromSeller();
                }
            }
        }
    };

    actualizarCDNSeller = async (codigo) => {
        const cdnsActuales = this.props.seller?.cdn ?? [];
        const cdnsOriginales = this.state.originalCdns ?? [];
        const cdnsActualesSinEliminados = cdnsActuales.filter(cdn => !cdn.eliminado);

        const cdnsEliminados = cdnsOriginales.filter(original => {
            const sigueExistiendo = cdnsActualesSinEliminados.some(actual => actual.id === original.id);
            return !sigueExistiendo;
        });

        const cdnsModificados = cdnsActualesSinEliminados
            .filter(cdnActual => cdnActual.idSeller !== null)
            .map(cdnActual => ({
                id: cdnActual.id,
                descripcion: cdnActual.descripcion || "",
                urlDescktop: cdnActual.urlDescktop || "",
                urlMovile: cdnActual.urlMovile || "",
                vigenciaDesde: cdnActual.vigenciaDesde,
                vigenciaHasta: cdnActual.vigenciaHasta,
                linkRedireccion: cdnActual.linkRedireccion,
            }));
        const cdnsNuevos = cdnsActualesSinEliminados.filter(cdnActual => !cdnActual.id);

        if (cdnsModificados.length === 0 && cdnsNuevos.length === 0 && cdnsEliminados.length === 0) {
            return;
        }

        try {
            this.setState({ showSpinner: true });

            const requests = [];

            if (cdnsModificados.length > 0 || cdnsEliminados.length > 0) {
                const payload = {
                    idSeller: codigo,
                    bannersSellers: cdnsModificados
                };
                requests.push(() => updateCdnSellerApi(payload));
            }

            if (cdnsNuevos.length > 0) {
                const nuevosValidos = cdnsNuevos.filter(cdn =>
                    cdn.vigenciaDesde && cdn.vigenciaHasta
                );

                nuevosValidos.forEach(cdn => {
                    const request = {
                        descripcion: cdn.descripcion || "",
                        urlDescktop: cdn.urlDescktop || "",
                        urlRedireccion: cdn.linkRedireccion || "",
                        urlMovile: cdn.urlMovile || "",
                        idSeller: codigo,
                        fechaDesde: cdn.vigenciaDesde,
                        fechaHasta: cdn.vigenciaHasta,
                    };

                    requests.push(() => postCrearCdnSellerApi(request));
                });

                if (nuevosValidos.length < cdnsNuevos.length) {
                    toast.warn("Algunos CDNs nuevos fueron ignorados por no tener fechas válidas");
                }
            }

            if (requests.length > 0) {
                for (const req of requests) {
                    await req();
                }
                toast.success("CDNs actualizados, creados y eliminados con éxito");
            } else {
                this.props.navigate("/Sellers");
            }
        } catch (err) {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("Ocurrió un error al actualizar algunos CDNs");
            throw err;
        } finally {
            this.setState({ showSpinner: false });
        }
    };


    hayCambiosEnCDNs = () => {
        const cdnsActuales = this.props.seller?.cdn ?? [];
        const cdnsOriginales = this.state.originalCdns ?? [];
        const cdnsActualesSinEliminados = cdnsActuales.filter(cdn => !cdn.eliminado);

        const cdnsEliminados = cdnsOriginales.filter(original =>
            !cdnsActualesSinEliminados.some(actual => actual.id === original.id)
        );

        const cdnsModificados = cdnsActualesSinEliminados.filter(cdnActual => {
            const original = cdnsOriginales.find(c => c.id === cdnActual.id);
            return original && (
                original.descripcion !== cdnActual.descripcion ||
                original.urlDescktop !== cdnActual.urlDescktop ||
                original.urlMovile !== cdnActual.urlMovile ||
                original.vigenciaDesde?.substring(0, 10) !== cdnActual.vigenciaDesde?.substring(0, 10) ||
                original.vigenciaHasta?.substring(0, 10) !== cdnActual.vigenciaHasta?.substring(0, 10) ||
                original.linkRedireccion !== cdnActual.linkRedireccion
            );
        });

        const cdnsNuevos = cdnsActualesSinEliminados.filter(cdnActual => !cdnActual.id);

        return cdnsModificados.length > 0 || cdnsNuevos.length > 0 || cdnsEliminados.length > 0;
    };

    updateSeller = () => {
        const { seller, sellers } = this.props;
        const { hasPdf, hasCbuManual, promesaEntregaTemp } = this.state;

        if (hasPdf) {
            this.pdfDatoBancario();
        }

        if (hasCbuManual) {
            this.cargaManualCbuSeller();
        }

        this.asignarTipoPublicacion();
        const updatedSeller = {
            ...seller,
            promesaEntrega: promesaEntregaTemp
        };

        let sellersResponse = putSeller(updatedSeller);
        sellersResponse.then(res => {
            this.props.updateListSellers(sellers, updatedSeller)
                .then(() => {
                    toast.success(res.mensaje);
                    this.goBack(true);
                })
                .catch(err => {
                    if (err.response && err.response.data && err.response.data.errores) {
                        err.response.data.errores.forEach(error => toast.error(error));
                    } else {
                        toast.error("No pudo modificarse el seller");
                    }
                });
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo modificarse");
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    };

    pdfDatoBancario = async () => {
        const { archivoPdf, hasPdf } = this.state;
        const { seller } = this.props;

        if (hasPdf && archivoPdf) {
            try {
                const base64Pdf = await formatFile(archivoPdf);
                const base64SinHeader = base64Pdf.split(',')[1];
                const request = {
                    idSeller: seller.codigo,
                    base64PDF: base64SinHeader
                };

                postCargarDatosBancariosApi(request)
                    .then((response) => toast.success(response.data?.mensaje))
                    .catch((error) => {
                        const errores = error?.response?.data?.errores;
                        if (Array.isArray(errores)) {
                            errores.forEach(err => toast.error(err));
                        } else {
                            toast.error("Error al subir el archivo");
                        }
                    });
            } catch (e) {
                toast.error("Archivo inválido");
            }
        } else {
            toast.warning("No hay archivo PDF para subir");
        }
    };

    cargaManualCbuSeller = async () => {
        try {
            const { datosBancariosForm } = this.state;

            let params = {
                idBanco: datosBancariosForm.banco,
                idSeller: datosBancariosForm.idSeller,
                tipoCuenta: parseInt(datosBancariosForm.tipoCuenta),
                numeroCuenta: datosBancariosForm.numeroCuenta,
                cbu: datosBancariosForm.cbu
            }

            postCargarDatosBancariosManualApi(params)
                .then((response) => toast.success(response.data?.mensaje))
                .catch((error) => {
                    const errores = error?.response?.data?.errores;
                    if (Array.isArray(errores)) {
                        errores.forEach(err => toast.error(err));
                    } else {
                        toast.error("Error al cargar el formulario");
                    }
                });

        } catch (e) {
            toast.error("No se completó la carga del formulario");
        }
    }

    handlePdfFromBankData = (file) => {
        this.setState({
            archivoPdf: file,
            hasPdf: !!file,
        });
    };

    submitFromSeller = () => {
        let seller = this.props.seller;

        if (!isEmail(seller.email)) {
            toast.warn("e-Mail incorrecto");
            return;
        }

        this.setState({ showSpinner: true });
        //this.asignarTipoPublicacion();
        this.updateSeller();
    }

    asignarTipoPublicacion = () => {
        const { settedTiposPublicacion, seller } = this.props;

        const tiposArr = Array.isArray(settedTiposPublicacion)
            ? settedTiposPublicacion
            : (settedTiposPublicacion && typeof settedTiposPublicacion === 'object' && settedTiposPublicacion.codigo != null)
                ? [settedTiposPublicacion]
                : [];

        const idSellerRaw = seller?.codigo ?? seller?.idSeller ?? seller?.Codigo ?? seller?.IdSeller;
        const idSeller = parseInt(idSellerRaw, 10);

        const listaIdsTipoPublicacion = tiposArr
            .map((t) => resolveTipoPublicacionId(t))
            .filter((id) => id != null && Number.isFinite(id) && id > 0);

        const request = {
            idSeller: Number.isFinite(idSeller) && idSeller > 0 ? idSeller : 0,
            listaIdsTipoPublicacion
        };

        const continuarAsignacion =
            listaIdsTipoPublicacion.length > 0 &&
            Number.isFinite(idSeller) &&
            idSeller > 0 &&
            listaIdsTipoPublicacion.every((id) => id != null);

        if (continuarAsignacion) {
            if (request.listaIdsTipoPublicacion.length > 0) {
                const req = postTiposPublicacionAsociarSeller(request);
                req.then(res => {
                    toast.success("Tipo de publicación asociado");
                }).catch(err => {
                    toast.warn("Tipo de publicación no asociado");
                });
            }
        }
    }

    onDelete = () => {
        this.setState({ showSpinner: true });
        const { seller } = this.props;

        const req = deleteSellerApi(seller.codigo);
        req.then(res => {
            toast.success("Vendedor borrado");
            this.goBack(true);
        }).catch(err => {
            toast.error("No se pudo eliminar");
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    }

    goBack = (hasChanges = false) => {
        const { isCategory, isAdminMod } = this.props.userType;

        this.props.clearLogisticaForSeller(this.props.id); // limpia reducer

        if (isCategory || isAdminMod) {
            if (hasChanges) {
                // this.props.resetSellers()
            }
            this.props.navigate("/Sellers");
        } else {
            this.props.navigate("/");
        }
    }

    onSave = async () => {
        this.onSubmit();
    }

    onCancel = () => {
        this.goBack();
    }

    onLogout = () => {
        // Auth.logout(); // This line was removed as per the new_code, as Auth is no longer imported.
        this.props.navigate("/");
    }

    handleChangeZonas = (zonas) => {
        this.setState({ logisticaPropiaZonas: zonas });
    };


    handleChangeEscalas = (escalas) => {
        this.setState({ logisticaPropiaEscalas: escalas });
    };

    handleBankDataChange = (data) => {
        this.setState({
            datosBancariosForm: data,
            hasCbuManual: true,
        });
    };

    openStorePreview = (e) => {
        e.preventDefault();
        const { seller } = this.props;
        let slug = seller?.slugTienda || "";
        slug = slug.replace(/['"]+/g, '');

        if (slug) {
            window.open(`https://www.megatone.net/tiendas/${slug}/`, '_blank');
        } else {
            toast.warn("La tienda no tiene una url asignada");
        }
    }

    render() {
        const { isCategory, isAdminMod } = this.props.userType || {};
        const { seller } = this.props;

        let codigo = seller?.codigo ?? "";
        let hideLoader = false;
        if (codigo !== undefined) {
            hideLoader = true;
        }

        let slug = seller?.slugTienda || "";
        slug = slug.replace(/['"]+/g, '');

        // Construir tabs dinámicamente en cada render para que los props estén siempre actualizados
        const tabs = [
            { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos estado={seller.estado} /> },
            { name: "Datos de contactos", icon: "ti-home", content: <DatosContactos /> },
            { name: "Publicación", icon: "ti-home", content: <Publicacion history={this.props.history} /> },
            { name: "Moderador", icon: "ti-home", content: <Moderador tipoUsuario={this.props.tipoUsuario} changeTab={this.onChangeActiveTab} navigate={this.props.navigate} location={this.props.location} /> },
            { name: "Administrar Cuenta", icon: "mdi mdi-email-outline", content: <MailUsuario /> },
            { name: "Liquidacion", icon: "mdi mdi-google-analytics", content: <Liquidacion tipoUsuario={this.props.tipoUsuario} /> },
            ...(isCategory || isAdminMod ? [
                { name: "Banner Tienda", icon: "ti-home", content: <BannerTienda tipoUsuario={this.props.tipoUsuario} /> }
            ] : []),
            { name: "Datos Bancarios", icon: "mdi mdi-tag", content: <DatosBancarios tipoUsuario={this.props.tipoUsuario} onSendPdf={this.handlePdfFromBankData} idSeller={parseInt(this.props.id)} onChangeBankData={this.handleBankDataChange} /> },
            ...(this.props.userType?.isSellerAdmin ? [
                {
                    name: "ZIP Nova",
                    icon: "ti-home",
                    content: (
                        <Zipnova
                            tipoUsuario={this.props.tipoUsuario}
                            idSeller={parseInt(this.props.id)}
                            id={this.props.userId}
                        />
                    )
                }
            ] : []),
            // Agregar Logística Propia solo si corresponde
            ...(seller.envioPropio === true ? [
                {
                    name: "Logística Propia",
                    icon: "ti-home",
                    content: (
                        <LogisticaPropia
                            idSeller={this.props.id}
                            userType={this.props.userType}
                            readOnly={!(this.props.userType.isSellerAdmin || this.props.userType.isSeller)}
                            zonas={this.state.logisticaPropiaZonas}
                            onChangeZonas={this.handleChangeZonas}
                            logisticaPropia={seller.logisticaPropia}
                        />
                    )
                }
            ] : []),
        //    { name: "Entrega", icon: "mdi mdi-truck", content: <EntregaTab value={this.state.promesaEntregaTemp} onChange={this.handlePromesaEntregaChange} /> },
        ];

        return (
            <div className="container">
                <div className="row align-items-center">

                    {!hideLoader ? <BigSpinner /> :
                        <div className="card">
                            <div className="card-body">
                                <div className="row align-items-center justify-content-between mb-3">
                                    <div className="col-auto">
                                        <div onClick={() => this.goBack()} style={{ cursor: 'pointer' }}>
                                            <GoBackArrow />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h4 className="card-title mb-1">
                                            {this.props.userName} - {seller?.razonSocial}
                                        </h4>
                                        <h6 className="card-subtitle text-muted">Editar Seller - {codigo}</h6>
                                    </div>
                                    <div className="col-auto">
                                        <button
                                            className="btn btn-secondary waves-effect waves-light"
                                            onClick={this.openStorePreview}
                                            title={`Slug: ${slug || 'N/A'}`}
                                            disabled={!slug}
                                            style={{ backgroundColor: '#78A3BA', borderColor: '#78A3BA' }}
                                        >
                                            <i className="mdi mdi-store mr-2"></i>Pagina de la Tienda
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body p-b-0">

                                <ul className="nav nav-tabs customtab" role="tablist">
                                    {
                                        this.state.tabs.map((tab, index) => {
                                            return <div key={index} onClick={() => this.onChangeActiveTab(index)}>
                                                <Tab name={tab.name} icon={tab.icon} isActive={index === this.state.activeTab} />
                                            </div>
                                        })
                                    }
                                </ul>

                                <form className="form-horizontal form-material p-10">
                                    <div className="tab-content">

                                        {this.state.tabs[this.state.activeTab].content}

                                        <div className="row align-items-center justify-content-center mb-3 text-center">

                                            <div className="col-12 col-sm-auto" hidden={!this.state.showSpinner}>
                                                <MiniSpinner />
                                            </div>

                                            <div className="d-flex justify-content-center">
                                                <button
                                                    onClick={this.onSubmit}
                                                    type="submit"
                                                    className="btn btn-sm background-rojo-megatone waves-light mx-1"
                                                    disabled={this.state.showSpinner}
                                                >
                                                    Guardar
                                                </button>

                                                {(isCategory || isAdminMod) &&
                                                    <ModalItem
                                                        btnStyle="btn btn-sm btn-grey mx-1"
                                                        btnText="Eliminar"
                                                        text="¿Desea eliminar Seller?"
                                                        disabled={this.state.showSpinner}
                                                        onDelete={this.onDelete}
                                                        show={this.state.showModal}
                                                    />
                                                }

                                                <button
                                                    onClick={() => this.goBack()}
                                                    className="btn btn-sm btn-light waves-effect waves-light mx-1"
                                                >
                                                    Cancelar
                                                </button>
                                            </div>

                                        </div>

                                    </div>
                                </form>

                            </div>
                        </div>
                    }

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    usuario: state.usuarios.user,
    userName: state.general.userName,
    userType: state.general.userType,
    tipoUsuario: state.general.tipoUsuario,
    facturaciones: state.facturaciones,
    usuarioError: state.usuarios.error,
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,
    //settedTiposPublicacion: state.publicaciones.tiposPublicacion,
    seller: selectSellerMerged(state),
    sellers: state.sellers.sellers,
    userId: state.general.userId,
});

export default withNavigation(connect(mapStateToProps, {
    fetchSeller,
    editUsuario,
    editando,
    setObject,
    fetchTiposPublicacionAdmById,
    resetSellers,
    updateListSellers,
    fetchUsuarios,
    clearLogisticaForSeller
})(SellerEditWrapper));